var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg020Boots = function Svg020Boots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437 301h-53.793c-38.126 0-72.491-15.022-97.989-39.28l-70.717 40.818-15-25.986 65.775-37.967c-2.831-4.189-4.883-8.888-7.262-13.383l-75.315 20.178-7.764-28.975 71.891-19.261c-1.476-5.294-2.743-10.613-3.605-16.144H167v-30h74v-30h-74V91h74V31h-15C104.317 31 29.059 85.067 0 96.728V361h213.71l60 30H512v-15c0-41.353-33.647-75-75-75M206.62 391H0v90h181v-30h11.455l60 30H512v-60H266.62z"
  })));
};
export default Svg020Boots;